// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"WebinarHero_textWrapper__VjHx6","buttonReadMore":"WebinarHero_buttonReadMore__DHGa9","shortDescription":"WebinarHero_shortDescription__s8_o6"};